import type { Runtime } from '@/core/enums/runtime.enum'
import type { ClassData, ConstructorData } from '@/core/types/library.type'

import type { UseMemberExecutionResult } from './types'
import { useMemberExecution } from './useMemberExecution'

export interface UseConstructorExecutionParams {
  constructor: ConstructorData
  constructorKey?: string
  classData: ClassData
  runtimeName: Runtime
}

export function useConstructorExecution({
  constructor,
  constructorKey,
  classData,
  runtimeName,
}: UseConstructorExecutionParams): UseMemberExecutionResult {
  return useMemberExecution({
    member: { kind: 'constructor', constructor, constructorKey },
    classData,
    runtimeName,
  })
}
